<template>
  <div>
    <div>
      <h3 class="page-title text-center">{{ title }}</h3>
      <petty-cash-certificate-list-box
        :visibleCertificateList="true"
        :rows="rows"
        :columns="columns"
        :loading="loading"
        :showPagination="true"
        :downloadClicked="downloadClicked"
        :downloadValue="downloadValue"
        :downloadMax="downloadMax"
        :pagination="pagination"
        @edit="onEdit"
        @approve="handleApprove"
        @reject="handleReject"
        @downloadCertificate="handleDownload"
        @downloadBulk="handleBulkDownload"
      ></petty-cash-certificate-list-box>
    </div>
    <div style="display: none">
      <pdf-download-format ref="pdfDownloadFormat"></pdf-download-format>
    </div>
  </div>
</template>

<script>
import JSZip from 'jszip';
import html2pdf from 'html2pdf.js';
import { mapActions, mapState } from 'vuex';
import router from '@/router';
import PettyCashCertificateListBox from '@/components/PettyCash/Certificate/PettyCashCertificateListBox.vue';
import PdfDownloadFormat from '@/components/PettyCash/Certificate/pdfDownloadFormat.vue';

export default {
  name: 'PettyCashCertificateList',
  components: {
    PettyCashCertificateListBox,
    PdfDownloadFormat
  },
  data() {
    return {
      columns: [
        { id: 'select', headerText: 'Select', textKey: 'select', width: '4%' },
        { id: 'index', headerText: 'S.NO.', textKey: 'index', width: '4%' },
        { id: 'company', headerText: 'Company', textKey: 'company', width: '6%' },
        { id: 'storeid', headerText: 'Store Id', textKey: 'storeid', width: '4%' },
        { id: 'storeName', headerText: 'Store Name', textKey: 'storeName', width: '6%' },
        { id: 'mainCash', headerText: 'Main Cash', textKey: 'mainCash', width: '12%' },
        { id: 'onlineCash', headerText: 'Online Cash', textKey: 'onlineCash', width: '12%' },
        { id: 'floatCash', headerText: 'Float Cash', textKey: 'floatCash', width: '12%' },
        { id: 'pettyCash', headerText: 'Petty Cash', textKey: 'pettyCash', width: '12%' },
        {
          id: 'quarter',
          headerText: 'Quarter',
          textKey: 'quarter',
          width: '5%'
        },
        { id: 'currentStatus', headerText: 'Status', textKey: 'currentStatus', width: '6%' },
        { id: 'rejectedRemarks', headerText: 'Rejected Remarks', textKey: 'rejectedRemarks', width: '7%' },
        { id: 'tlDmName', headerText: 'TL Name', textKey: 'tlDmName', width: '4%' },
        { id: 'functions', headerText: 'Functions', textKey: 'functions', width: '6%' }
      ],
      rows: [],
      isSsm: false,
      storeManagerName: '',
      downloadClicked: false,
      downloadValue: 0,
      downloadMax: 0
    };
  },
  mounted() {
    this.listCashCertificate({ query: {} });
    if (this.user && this.user.roles) {
      this.user.roles.map(item => {
        if (item.name === 'STORE_SALES_MANAGER') {
          this.isSsm = true;
        }
      });
    }
  },
  computed: {
    ...mapState('pettyCash', ['cashCertificateList', 'loading', 'pagination']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store']),
    title() {
      return 'Cash Certificate List';
    }
  },
  methods: {
    ...mapActions('pettyCash', ['listCashCertificate', 'patchCashCertificate']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    handleColumnWidth(column) {
      return { width: column.width };
    },
    onEdit({ row }) {
      router.push(`/petty-cash/certificate/${row.id}`);
    },
    handleApprove({ row }) {
      this.patchCashCertificate({
        id: row.id,
        newCashCertificate: row,
        router: router,
        redirectUrl: '/petty-cash/certificate'
      });
      location.reload();
      this.loading = false;
    },
    handleReject({ row }) {
      this.patchCashCertificate({
        id: row.id,
        newCashCertificate: row,
        router: router,
        redirectUrl: '/petty-cash/certificate'
      });
      location.reload();
      this.loading = false;
    },
    handleDownload(row) {
      this.$refs.pdfDownloadFormat.downloadRow = row;
      this.$refs.pdfDownloadFormat.storeManagerName = this.storeManagerName;
      const element = this.$refs.pdfDownloadFormat.$el;
      const opt = {
        margin: 1,
        filename: 'store-details.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      };

      html2pdf().set(opt).from(element).save();
    },
    // handle separate bulk download of all files

    // handleBulkDownload(rows) {
    //   const downloadPdf = item => {
    //     return new Promise(resolve => {
    //       this.$refs.pdfDownloadFormat.downloadRow = [item];
    //       this.$refs.pdfDownloadFormat.storeManagerName = this.storeManagerName;
    //       const element = this.$refs.pdfDownloadFormat.$el;
    //       const opt = {
    //         margin: 1,
    //         filename: `${item.storeid}.pdf`,
    //         image: { type: 'jpeg', quality: 0.98 },
    //         html2canvas: { scale: 2 },
    //         jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    //         pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    //       };

    //       html2pdf()
    //         .set(opt)
    //         .from(element)
    //         .save()
    //         .then(() => {
    //           resolve();
    //         });
    //     });
    //   };

    //   rows.reduce((promise, item) => {
    //     return promise.then(() => downloadPdf(item));
    //   }, Promise.resolve());
    // }

    // handle bulk download of all files into a zip
    handleBulkDownload(rows) {
      if (rows.length > 0) {
        this.downloadClicked = true;
        this.downloadMax = rows.length;
        this.downloadValue = 0;

        const downloadPdf = item => {
          return new Promise(resolve => {
            this.$refs.pdfDownloadFormat.downloadRow = [item];
            this.$refs.pdfDownloadFormat.storeManagerName = this.storeManagerName;
            const element = this.$refs.pdfDownloadFormat.$el;
            const opt = {
              margin: 1,
              filename: `${item.storeid}.pdf`,
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
              pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
            };

            html2pdf()
              .set(opt)
              .from(element)
              .outputPdf('blob')
              .then(blob => {
                this.downloadValue++;
                resolve({ blob, filename: `${item.id}.pdf` });
              });
          });
        };

        const zip = new JSZip();
        rows
          .reduce((promise, item) => {
            return promise.then(() => {
              return downloadPdf(item).then(({ blob, filename }) => {
                zip.file(filename, blob);
              });
            });
          }, Promise.resolve())
          .then(() => {
            return zip.generateAsync({ type: 'blob' });
          })
          .then(content => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = 'cashcertificate.zip';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.downloadClicked = false;
          })
          .catch(error => {
            console.error('Error generating or downloading ZIP file:', error);
            this.downloadClicked = false;
          });
      }
    }
  },
  watch: {
    cashCertificateList(newValue) {
      if (newValue.length > 0) {
        this.rows = [...newValue];
      }
    },
    store(newValue) {
      if (newValue && newValue.length > 0) {
        newValue.map(item => {
          this.storeManagerName = item.storeManagerName;
        });
      }
    }
  }
};
</script>
